<template>
	<div class="order-detail-body">
		<!-- <div class="shop-position">
			<img src="~/images/icon/position-icon.png">
			当前卖家店铺：<span style="color: #64B0FF"> {{ shopName }}</span>
		</div> -->
		<div class="order-detail-header">
			<img src="~/images/icon/position.png" alt="" class="position">
			<div class="my-position">您的位置：</div>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>
					<span class="go-back-span" @click="goBack('all')">退单</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item>
					<span class="go-back-span" @click="goBack('single')">{{orderstatusName}}</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item>退单详情</el-breadcrumb-item>
			</el-breadcrumb>
			<el-button size="small" style="margin-left: auto;margin-right: 20px;" type="primary" plain @click="printerEvent">打印</el-button>
		</div>
		<div class="order-detail-info">
			<div class="info-left">
				<div class="info-left-container">
					<DetailInfo
						:canEdit='canEdit'
						:matchbillcenterflag='matchbillcenterflag'
						:showBtn1='orderstatus === 0 && AuthorityList["07_0002_0003_00"]'
						:showBtn2='orderstatus === 1 && AuthorityList["07_0002_0009_00"]'
						:showBtn3='!(detailData.cause === 6 || detailData.cause === 7) && (pushstate === "2" || pushstate === "0") && orderstatus === 3 && matchbillcenterflag === 1 && AuthorityList["07_0002_0009_00"]'
						:detailData='detailData'/>
					<!-- <Arbitrationinfo v-if="(orderstatus === 1 || orderstatus === 2 || orderstatus === 3) && showArbitrationinfo" class="arbitrationinfo-div" :Arbitrationinfo='Arbitrationinfo' /> -->
					<GoodsInfo
						ref="goodsInfo"
						:goodData='goodData'
						:resData='resData'
						:deliveryData='deliveryData'
						:autoflag='autoflag'
						:orderstatusName='orderstatusName'
						:canEdit='canEdit'
						:matchbillcenterflag='matchbillcenterflag'/>
				</div>
				<div class="info-btn">
					<el-button size="small" class="btn" v-if="canEdit" @click="editCancel">取消</el-button>
					<el-button size="small" class="btn" v-if="AuthorityList['07_0002_0003_00'] && canEdit" @click="editSave">保存</el-button>
					<el-button size="small" class="btn" v-if="orderstatus === 0 && AuthorityList['07_0002_0003_00'] && !canEdit && detailData.autorefundflag !== 1 && rejectflag !==1" @click="edit">编辑</el-button>
					<el-button size="small" class="btn" v-if="orderstatus === 0 && AuthorityList['07_0002_0003_00'] && !canEdit && detailData.autorefundflag !== 1 && rejectflag !==1 && !valetFlag" @click="refuse">驳回</el-button>
					<el-button size="small" class="btn" v-if="(orderstatusName === '已同意' || (orderstatusName === '待处理' && refundpush)) && AuthorityList['07_0002_0009_00'] && matchbillcenterflag === 1" @click="pullClick">重新推送</el-button>
					<el-button size="small" class="btn" v-if="AuthorityList['07_0003_0001_00'] && !canEdit" @click="goValet">代客下单</el-button>
					<el-button class="btn" size="small" v-if='orderstatus === 0 && AuthorityList["07_0002_0003_00"] && !canEdit' @click='reject'>拒绝</el-button>
					<el-button class="btn" size="small" v-if='orderstatus === 0 && AuthorityList["07_0002_0003_00"] && !canEdit' @click='btnClick(1)'  type="primary">同意退款</el-button>
					<el-button class="btn" size="small" v-if='orderstatus === 1 && AuthorityList["07_0002_0009_00"] && !canEdit && matchbillcenterflag !== 1 ' @click='btnClick(3)'  type="primary">退货完成</el-button>
					<el-button class="btn" style="float:right" size="small" v-if='!(detailData.cause === 6 || detailData.cause === 7) && (pushstate === "2" || pushstate === "0") && orderstatus === 3 && matchbillcenterflag === 1 && AuthorityList["07_0002_0009_00"] && !canEdit' @click='pullClick' plain type="primary">手动同步云数据</el-button>
				</div>
			</div>
			<div class="info-right">
				<DeliveryInfo :deliveryData='deliveryData'/>
			</div>
			<el-dialog
			title="拒绝原因"
			:visible.sync="rejectModal"
			:close-on-click-modal="false"
			class="dialog-title"
			width="400px"
			>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="1">质量无问题</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="2">超出退货时间</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="3">问题已解决</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="4">该商品不符合无理由退货</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="5">影响二次销售</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="cancelcause" :label="6">其他原因</el-radio>
				</div>
				<el-input @change='othercauserChange' style="margin-bottom: 10px;" :maxlength="50" :disabled="cancelcause !== 6" type="textarea" v-model="othercauser"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button class="fx-big-btn" type="primary" plain size='small' @click="cancel">取 消</el-button>
					<el-button class="fx-big-btn" type="primary" plain size='small' @click="save">确 定</el-button>
				</span>
			</el-dialog>
			<el-dialog
			title="驳回原因"
			:visible.sync="refuseModal"
			:close-on-click-modal="false"
			class="dialog-title"
			width="400px"
			>
				<div class="radio">
					<el-radio v-model="rejectCause" :label="1">退单数据有问题</el-radio>
				</div>
				<div class="radio">
					<el-radio v-model="rejectCause" :label="2">其他原因</el-radio>
				</div>
				<el-input @change='refuseCauserChange' style="margin-bottom: 10px;" :maxlength="50" :disabled="rejectCause !== 2" type="textarea" v-model="rejectCauser"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button class="fx-big-btn" type="primary" plain size='small' @click="cancelreject">取 消</el-button>
					<el-button class="fx-big-btn" type="primary" plain size='small' @click="savereject">确 定</el-button>
				</span>
			</el-dialog>
			<el-dialog
			title="打印设置"
			:visible.sync="printerVisible"
			class="dialog-title"
			width="530px">
				<Print :ids="[params.refundid]" :templateType="1" v-if="printerVisible"/>
		</el-dialog>
		</div>
	</div>
</template>

<script>
import DetailInfo from '@/components/refundOrderDetail/DetailInfo.vue'
import GoodsInfo from '@/components/refundOrderDetail/GoodsInfo.vue'
import DeliveryInfo from '@/components/refundOrderDetail/DeliveryInfo.vue'
// import Arbitrationinfo from '@/components/refundOrderDetail/arbitrationinfo.vue'
import Print from '@/components/print/Print.vue'
export default {
	name: 'orderDetail',
	components: {
		DetailInfo,
		GoodsInfo,
		DeliveryInfo,
		Print
		// Arbitrationinfo
	},
	data () {
		return {
			refundpush: false,
			autoflag: false,
			othercauser: '',
			rejectCause: 1,
			rejectCauser: '',
			showArbitrationinfo: false,
			printerVisible: false,
			Arbitrationinfo: {
				verifyResult: null,
				applyDate: '',
				verifyDate: '',
				adminLoginName: '',
				verifyReason: ''
			},
			refundId: '',
			pusherrorreson: '',
			pushstate: null,
			orderstatusName: '',
			cancelcause: 1,
			rejectModal: false,
			refuseModal: false,
			orderstatus: null,
			refundstatusid: null,
			refundway: null,
			payStatus: null,
			shopName: '',
			detailData: {
				ordernumber: null,
				refundstatus: null,
				refundMethod: null,
				refundway: null,
				payStatus: null,
				cause: null,
				orderstatus: null,
				memo: null,
				refundImgs: null,
				createdate: null,
				liquidateflag: null
			},
			deliveryData: {
				ordernumber: null,
				ob_btel: null,
				ob_storename: null,
				os_entname: null,
				ob_name: null,
				createdate: null,
				fulfillment: null,
				ob_address: null,
				os_organid: null
			},
			AuthorityList: {
				'07_0002_0001_00': false,
				'07_0002_0002_00': false,
				'07_0002_0003_00': false,
				'07_0002_0004_00': false,
				'07_0002_0005_00': false,
				'07_0002_0006_00': false,
				'07_0002_0007_00': false,
				'07_0002_0008_00': false,
				'07_0002_0009_00': false,
				'07_0002_0010_00': false,
				'07_0002_0011_00': false,
				'07_0002_0012_00': false,
				'07_0002_0013_00': false,
				'07_0002_0014_00': false,
				'07_0002_0015_00': false,
				'07_0003_0001_00': false
			},
			goodData: [],
			params: {},
			matchbillcenterflag: 0,
			resData: {},
			customercategoryid: '',
			customerId: '',
			returnOrderNumber: '',
			canEdit: false,
			rejectflag: 0,
			valetFlag: false
		}
	},
	created () {
		this.$fxEventBus.$on('reloadReturnOrder', () => {
			this.$fxEventBus.$emit('setMenu', '6-2')
			this.getAuthority('07_0002_0000_00')
			let a = window.sessionStorage.getItem('refundOrderParams')
			this.params = JSON.parse(a)
			this.checkSmallCategory()
			this.getInfo()
		})
		this.getSyscodeid()
		this.$fxEventBus.$emit('setMenu', '6-2')
		this.getAuthority('07_0002_0000_00')
		this.getAuthority('07_0003_0000_00')
		let a = window.sessionStorage.getItem('refundOrderParams')
		this.params = JSON.parse(a)
		this.checkSmallCategory()
		this.getInfo()
	},
	methods: {
		printerEvent () {
			this.printerVisible = true
		},
		edit () {
			this.canEdit = true
		},
		editCancel () {
			this.canEdit = false
			this.getInfo()
		},
		editSave () {
			this.$refs.goodsInfo.updateRefundQuantity().then(() => {
				this.canEdit = false
				this.getInfo()
			})
		},
		cancelreject () {
			this.rejectCause = 1
			this.refuseModal = false
			this.rejectCauser = ''
		},
		savereject () {
			// console.log(this.params)
			// console.log(this.rejectCause)
			let rejectCauser = ''
			if (this.rejectCause === 1) {
				rejectCauser = '退单数据有问题'
			} else if (this.rejectCause === 2) {
				rejectCauser = this.rejectCauser
			}
			// console.log(rejectCauser)
			let params = {
				refundid: this.params.refundid,
				rejectFlag: 1,
				rejectCause: rejectCauser
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/refundorder/rejectRefundOrder`,
				data: params
			}).then(res => {
				if (res.result) {
					this.rejectCause = 1
					this.refuseModal = false
					this.rejectCauser = ''
					this.$message.success('驳回成功')
				} else {
					this.$message.error(res.msg)
				}
				this.getInfo()
			})
		},
		refuse () {
			this.refuseModal = true
		},
		othercauserChange () {
			this.othercauser = this.othercauser.trim()
			this.othercauser = this.othercauser.replace(/[',\\]/g, '')
		},
		refuseCauserChange () {
			this.rejectCauser = this.rejectCauser.trim()
			this.rejectCauser = this.rejectCauser.replace(/[',\\]/g, '')
		},
		// 是否开启小类
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
			})
			// })
		},
		pullClick () {
			let params = {
				statusid: this.refundstatusid,
				refundorderid: this.refundId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/match/handPushRefundOrderToOtherPlatform`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功')
				} else {
					this.$message.error(res.msg)
				}
				this.getInfo()
			})
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		goBack (data) {
			let a = JSON.parse(window.sessionStorage.getItem('refundTab'))
			if (data === 'all') {
				a.active = '全部退单'
				a.orderStatus = this.orderstatus
			} else {
				a.active = this.orderstatusName
				a.orderStatus = this.orderstatus
			}
			window.sessionStorage.setItem('refundTab', JSON.stringify(a))
			this.$router.push('/main/refundOrder')
		},
		cancel () {
			this.rejectModal = false
		},
		save () {
			this.btnClick(2)
		},
		reject () {
			console.log(this.rejectflag)
			if (this.rejectflag === 1) {
				this.$message.error('驳回中，单据编辑处理后，才可继续操作该退单！')
				return false
			}
			this.rejectModal = true
			this.cancelcause = 1
		},
		btnClick (data) {
			let logger = null
			if (data === 1 || data === 3) {
				let msg = '[' + this.returnOrderNumber + ']点击' + (data === 1 ? '同意退单' : '退单成功')
				logger = this.$fxLogger.createInfo('order.order_detail.editReturn', { msg: msg })
			}
			if (this.rejectflag === 1) {
				this.$message.error('驳回中，单据编辑处理后，才可继续操作该退单！')
				return false
			}
			let params = {
				action: data,
				refundstatus: this.orderstatus,
				refundstatusid: this.refundstatusid,
				refundway: this.refundway
			}
			if (data === 2) {
				params.cancelcause = this.cancelcause
				params.memo = this.othercauser
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/updateRefundStatus`,
				data: params,
				logger
			}).then(res => {
				if (res.result === true) {
					this.$message.success('操作成功！')
					this.rejectModal = false
					this.getInfo()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		changeName () {
			switch (this.orderstatus) {
			case 0:
				this.orderstatusName = '待处理'
				break
			case 1:
				this.orderstatusName = '已同意'
				break
			case 2:
				this.orderstatusName = '已拒绝'
				break
			case 3:
				this.orderstatusName = '退货完成'
				break
			}
		},
		getSyscodeid () {
			let formData = new FormData()
			formData.append('funname', 'refundpush')
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/organ/customized`,
				data: formData
			}).then(res => {
				if (res.result) {
					let syscodeid = window.sessionStorage.getItem('entid')
					this.refundpush = res.data.refundpush.includes(syscodeid)
				}
			})
		},
		getInfo () {
			let windowId = window.sessionStorage.getItem('windowId')
			let params = {
				windowId: windowId,
				refundorderid: this.params.refundid,
				messageid: this.params.messageId || ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/refundorder/getdetail/`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$fxEventBus.$emit('getMsgNum')
					window.sessionStorage.removeItem('windowId')
					this.returnOrderNumber = res.data.ordernumber
					this.autoflag = res.data.autoflag
					this.refundId = res.data.refundId
					this.pushstate = res.data.pushstate
					this.pusherrorreson = res.data.pusherrorreson
					this.shopName = res.data.seller.os_shopname
					this.orderstatus = res.data.orderstatus
					this.refundway = res.data.refundway
					this.refundstatusid = res.data.statusid
					this.customercategoryid = res.data.customerCategoryId
					this.customerId = res.data.customerId
					this.rejectflag = res.data.rejectflag
					this.payStatus = res.data.payStatus
					if (res.data.ordersource === 1) {
						this.valetFlag = true
					} else {
						this.valetFlag = false
					}
					let addr = ''
					if (res.data.buyer.ob_address.indexOf('{"detail') > 0) {
						let acceptAddr1 = res.data.buyer.ob_address.slice(0, res.data.buyer.ob_address.indexOf('{"detail'))
						let acceptAddr2 = res.data.buyer.ob_address.slice(res.data.buyer.ob_address.indexOf('{"detail'))
						addr = acceptAddr1 + JSON.parse(acceptAddr2).detail + JSON.parse(acceptAddr2).local
					} else {
						addr = res.data.buyer.ob_address
					}
					if (res.data.arbitrationinfo !== null) {
						this.showArbitrationinfo = true
						this.Arbitrationinfo = {
							verifyResult: res.data.arbitrationinfo.verifyResult,
							applyDate: res.data.arbitrationinfo.applyDate,
							verifyDate: res.data.arbitrationinfo.verifyDate,
							adminLoginName: res.data.arbitrationinfo.adminLoginName,
							verifyReason: res.data.arbitrationinfo.verifyReason
						}
					}
					this.detailData = {
						backmoney: res.data.backmoney,
						modifydate: res.data.modifydate,
						autorefundflag: res.data.autorefundflag,
						sourcetype: res.data.sourcetype,
						totalprice: res.data.initialfinalmoney,
						refundPayId: res.data.refundPayId,
						refundId: res.data.refundId,
						orderId: res.data.order.orderId,
						refundstatus: res.data.refundstatus,
						cancelcause: res.data.cancelcause,
						ordernumber: res.data.ordernumber,
						refundImgs: res.data.refundImgs,
						refundMethod: res.data.refundMethod,
						refundway: res.data.refundway,
						cause: res.data.cause,
						orderstatus: res.data.orderstatus,
						memo: res.data.memo,
						createdate: res.data.createdate,
						liquidateflag: res.data.liquidateflag,
						othercauser: res.data.othercauser,
						paymentnumber: res.data.paymentnumber,
						payStatus: res.data.payStatus,
						paymentserialnumberArr: res.data.paymentserialnumber,
						outrefundnumber: res.data.outrefundnumber,
						refundnumber: res.data.refundnumber
					}
					this.deliveryData = {
						customerCategoryName: res.data.customerCategoryName,
						customerName: res.data.customerName,
						refundid: this.params.refundid,
						ordernumber: res.data.order.ordernumber,
						ob_btel: res.data.buyer.ob_btel,
						ob_storename: res.data.buyer.ob_storename,
						ob_entname: res.data.buyer.ob_entname,
						ob_name: res.data.buyer.ob_name,
						createdate: res.data.order.createdate,
						ob_address: addr,
						fulfillment: res.data.fulfillment,
						isSellerpull: res.data.order.isSellerpull !== 0,
						billState: res.data.order.billState,
						buypullstate: res.data.order.buypullstate,
						orderId: res.data.order.orderId,
						statusId: res.data.order.statusid,
						differ: +res.data.order.differ,
						sellerShopId: res.data.seller.os_shopid,
						os_organid: res.data.seller.os_organid,
						orderForConsumerList: res.data.orderForConsumerList,
						selfPickFlag: res.data.selfPickFlag,
						selfPickDate: res.data.selfPickDate,
						selfPickAddress: res.data.selfPickAddress,
						selfPickLinkName: res.data.selfPickLinkName,
						selfPickTel: res.data.selfPickTel
					}
					this.resData = res.data
					res.data.goodsData.forEach(item => {
						if (item.commpressflag) {
							if (item.imgurl) {
								item.imgurl = this.$fxUtils.changeImgSrc(item.imgurl, 'big')
							}
						}
					})
					this.goodData = res.data.goodsData
					this.changeName()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		goValet () {
			let params = {
				customercategoryid: this.customercategoryid,
				id: this.customerId
			}
			let params2 = {
				refundOrderId: this.refundId,
				customerId: this.customerId,
				customerCategoryId: this.customercategoryid,
				shopId: this.deliveryData.sellerShopId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/checkCustomer`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.refundValetOrder(params2).then(res => {
						res.data.productList.forEach(item => {
							if (item.commpressflag) {
								if (item.url) {
									item.url = this.$fxUtils.changeImgSrc(item.url, 'big')
								}
							}
						})
						this.$router.push({ path: '/main/valetOrder', query: { refundFlag: true, dataObj: JSON.stringify(res.data) } })
					})
				} else {
					this.$message.error('客户已停用，无法下单！')
				}
			})
		},
		refundValetOrder (params) {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/replacorder/orderForCusumerInfo/find`,
					data: params
				}).then(res => {
					if (res.result) {
						resolve(res)
					} else {
						this.$message.error(res.error.msg)
					}
				}).catch(error => {
					this.$message.error(error.msg)
				})
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-detail-body {
	flex: 1
	display flex
	flex-direction column
	.dock-box{
		width :600px;
		text-align:left;
		position: relative;
		line-height :48px;
		height :0px;
		top:-50px;
		left :220px;
		font-size: 13px
	}
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-detail-header {
		height:50px;
		// line-height:50px;
		// text-align:left
		display: flex;
		align-items: center;
		font-size: 16px;
		// border-bottom 1px solid #DCE1FE
		.my-position {
			font-size: 14px;
			// display: inline-block;
			// position: relative;
			// top: -20px;
		}
		.position {
			width: 15px;
			height: 15px;
			// float: left;
			margin: 0px 11px 0 9px;
		}
		.el-breadcrumb {
			// display inline-block
			// height: 49px
			// line-height: 49px
			.go-back-span {
				font-weight: 700
				cursor: pointer
			}
		}
	}
	.order-detail-info {
		display flex;
		flex: 1;
		box-sizing :border-box;
		height: calc(100% - 110px);
		.info-left {
			display flex
			flex: 1
			height: 100%
			flex-direction column
			margin-right: 10px
			.info-left-container {
				display flex
				flex: 1
				flex-direction column
				overflow-y auto
			}
			.info-btn {
				padding: 20px
				text-align right
				.btn {
					width :130px;
					height :35px;
					margin-left :20px;
				}
			}
		}
		.info-right {
			display flex
			overflow-y :auto
			box-sizing: border-box
			width: 300px
		}
	}
	.radio{
		text-align :left
		margin :10px 0px 10px 10px
	}
}
</style>
<style lang="stylus">
.order-detail-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-dialog__footer{
		text-align :center
	}
}
</style>
